export const LogoFull = ({ className = "", size = "default" }) => {
  const sizes = {
    small: { width: 180, height: 50 },
    default: { width: 240, height: 65 },
    large: { width: 320, height: 85 }
  };

  const { width, height } = sizes[size];

  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 320 85" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Shield/Scale icon - Blue Neon */}
      <g transform="translate(0, 12)">
        {/* Outer shield */}
        <path 
          d="M30 5 L55 5 L55 35 Q55 50 42.5 58 Q30 50 30 35 Z" 
          stroke="#00D4FF" 
          strokeWidth="2" 
          fill="none"
        />
        {/* Inner balance scale */}
        <line x1="42.5" y1="15" x2="42.5" y2="45" stroke="#00D4FF" strokeWidth="1.5"/>
        <line x1="34" y1="22" x2="51" y2="22" stroke="#00D4FF" strokeWidth="1.5"/>
        {/* Scale pans */}
        <path d="M34 22 L31 30 L37 30 Z" fill="#00D4FF"/>
        <path d="M51 22 L48 30 L54 30 Z" fill="#00D4FF"/>
        {/* Base */}
        <rect x="39" y="45" width="7" height="3" fill="#00D4FF"/>
      </g>

      {/* FORTUNATO text */}
      <text 
        x="70" 
        y="42" 
        fontFamily="Playfair Display, serif" 
        fontSize="28" 
        fontWeight="700" 
        fill="#00D4FF"
        letterSpacing="3"
      >
        FORTUNATO
      </text>

      {/* LEGISLAI text */}
      <text 
        x="70" 
        y="68" 
        fontFamily="Manrope, sans-serif" 
        fontSize="18" 
        fontWeight="300" 
        fill="#F0F0F0"
        letterSpacing="8"
      >
        LEGISLAI
      </text>

      {/* Subtle line separator */}
      <line x1="70" y1="48" x2="200" y2="48" stroke="#00D4FF" strokeWidth="0.5" opacity="0.5"/>
    </svg>
  );
};

export const LogoMark = ({ className = "", size = 48 }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 60 60" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Shield background */}
      <path 
        d="M30 5 L55 10 L55 35 Q55 50 30 58 Q5 50 5 35 L5 10 Z" 
        fill="url(#shieldGradientBlue)"
        stroke="#00D4FF"
        strokeWidth="1.5"
      />
      
      {/* Inner balance scale */}
      <g transform="translate(0, 5)">
        <line x1="30" y1="12" x2="30" y2="38" stroke="#00D4FF" strokeWidth="2"/>
        <line x1="18" y1="18" x2="42" y2="18" stroke="#00D4FF" strokeWidth="2"/>
        {/* Scale pans */}
        <circle cx="18" cy="25" r="5" fill="none" stroke="#00D4FF" strokeWidth="1.5"/>
        <circle cx="42" cy="25" r="5" fill="none" stroke="#00D4FF" strokeWidth="1.5"/>
        {/* Base pedestal */}
        <rect x="26" y="38" width="8" height="4" rx="1" fill="#00D4FF"/>
      </g>

      <defs>
        <linearGradient id="shieldGradientBlue" x1="30" y1="5" x2="30" y2="58" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#000815"/>
          <stop offset="100%" stopColor="#000510"/>
        </linearGradient>
      </defs>
    </svg>
  );
};

export default LogoFull;
